//  const apiUrl = 'https://gizemtest.azurewebsites.net';
// const apiUrl = 'https://api.dev.makingview.com';
import {Api} from "@mui/icons-material";

// const apiUrl = 'https://localhost:7156';
 const apiUrl = process.env.REACT_APP_BASE_URL;
// const apiUrl = 'https://api.prod.makingview.com';

export const OtpUrl = apiUrl + '/api/OrgAdminUserAuth/SendSMS';
export const LoginUrl = apiUrl + '/api/OrgAdminUserAuth/Login';
export const RefreshOtp = apiUrl + '/api/OrgAdminUserAuth/Refresh';
export const UploadExcel = apiUrl + '/api/Integrations/UploadExcel';

export const ForgotPasswordUrl = apiUrl + '/api/OrgAdminUserAuth/ForgotPassword?email=';
export const PasswordResetUrl = apiUrl + '/api/OrgAdminUserAuth/ChangePassword';
export const GetRolesUrl = apiUrl + '/api/BaseUsers/GetAdminDetailsByToken';
export const GetUserDetail = apiUrl + '/api/BaseUsers/GetAdminDetailsByToken';
export const GetAllFundamentalRoles = apiUrl + '/api/Roles/GetFundamentalUserRoles';
export const GetAllAdmins = apiUrl + '/api/AdminUsers/GetAllAdmins';
// export const showLicense = apiUrl + '/api/Licenses/ShowLicense';
export const GetEntraIdTenancyUrl = apiUrl + '/api/entraid/auth/requesturl';
export const GetConflictingEntraIdUsers = apiUrl + '/api/entraid/users/getconflicting';
export const GetTenancyStatus = apiUrl + '/api/entraid/auth/isconnected';
export const DisconnectEntraIdTenancy = apiUrl + '/api/entraid/auth/disconnect';
export const GetAllCourses = apiUrl + '/api/Courses/GetAll';
export const GetAllUsers = apiUrl + '/api/EndUsers/GetAllUsersByDepartmentGroups';
export const AddAdmin = apiUrl + '/api/OrgAdminUserAuth/AddAdmin';
export const DeleteAdmin = apiUrl + '/api/OrgAdminUserAuth/DeleteAdmin';
export const ResendInvitation = apiUrl + '/api/Organizations/ResendInvitation';
export const AddTemplateFysisk = apiUrl + '/api/TemplateFysisk/Add';
export const AddTemplateMental = apiUrl + '/api/TemplateMental/Add';
export const AddTemplateForstehjelp = apiUrl + '/api/TemplateFirstAid/Add';
export const AddTemplateSecuritas = apiUrl + '/api/TemplateSecuritas/Add';
export const AddTemplateSykefravaer = apiUrl + '/api/TemplateSykefravaer/Add';
export const GetMentalTemplates = apiUrl + '/api/TemplateMental/GetAll';
export const GetFysiskTemplates = apiUrl + '/api/TemplateFysisk/GetAll';
export const GetForstehjelpTemplates = apiUrl + '/api/TemplateFirstAid/GetAll';
export const GetSecuritasTemplate = apiUrl + '/api/TemplateSecuritas/GetAll';
export const GetSykefravaerTemplate = apiUrl + '/api/TemplateSykefravaer/GetAll';
export const DeleteMentalTemplate = apiUrl + '/api/TemplateMental/Delete';
export const DeleteFysiskTemplate = apiUrl + '/api/TemplateFysisk/Delete';
export const DeleteForstehjelpTemplate = apiUrl + '/api/TemplateFirstAid/Delete';
export const DeleteSecuritasTemplate = apiUrl + '/api/TemplateSecuritas/Delete';
export const DeleteSykefravaerTemplate = apiUrl + '/api/TemplateSykefravaer/Delete';
export const AddCourses = apiUrl + '/api/Courses/Add';
export const DeleteCourses = apiUrl + '/api/Courses/Delete';
export const GetAllSchedulesByUpperAdmin = apiUrl + '/api/Schedules/GetAllSchedulesFromAllDepartments';
// export const DeleteScheduleCourseByUpperAdmin = apiUrl + '/api/Schedules/CancelAllSchedulesOfADepartmentByCourseIdAsUpperAdmin';
// export const DeleteScheduleCourseByDepartmentAdmin = apiUrl + '/api/Schedules/CancelAllSchedulesOfADepartmentAsDepartmentAdmin';
export const GetAllUsersOfADepartmentByToken = apiUrl + '/api/EndUsers/GetAllUsersOfADepartmentByToken';
export const GetAllDepartments = apiUrl + '/api/EndUsers/GetAllUsersByDepartmentGroups';
// export const GetDepartments = apiUrl + '/api/Departments/GetAllDepartments';
export const ContactUs = apiUrl + '/api/Contacts/RegisterMail';
export const GetCustomText = apiUrl + '/api/Schedules/GetCustomTexts';
export const GetCustomUninviteText = apiUrl + '/api/Schedules/GetCustomUninviteTexts';
export const GetCustomUpdateText = apiUrl + '/api/Schedules/GetCustomUpdateTexts';
export const AddScheduleByUpperAdmin = apiUrl + '/api/Schedules/AddByUpperAdmin';
export const AddScheduleByDepartmentAdmin = apiUrl + '/api/Schedules/AddByDepartmentAdmin';
export const RegisterAdmin = apiUrl + '/api/OrgAdminUserAuth/RegisterAdmin';
export const RegisterRootAdmin = apiUrl + '/api/OrgAdminUserAuth/RegisterRootAdmin';
export const GetUserResult = apiUrl + '/api/Results/GetAllResultsByUserId';
export const GetCourseDetails = apiUrl + '/api/Courses/GetDetail';
export const DeleteScheduleCourseAsUpperadmin = apiUrl + '/api/Schedules/CancelAllSchedulesByGroupId';
export const GetMentalTemplateDetails = apiUrl + '/api/TemplateMental/Get';
export const GetFysiskTemplateDetails =apiUrl + '/api/TemplateFysisk/Get';
export const GetForstehjelpTemplateDetails =apiUrl + '/api/TemplateFirstAid/Get';
export const GetSecuritasTemplateDetails =apiUrl + '/api/TemplateSecuritas/Get';
export const GetSykefravaerTemplateDetails =apiUrl + '/api/TemplateSykefravaer/Get';
export const CheckAvailableTemplates = apiUrl + '/api/Courses/CheckAvailableTemplates';
export const GeneralResultAsUpperAdmin = apiUrl + '/api/Results/GetGroupResultsByUpperAdmin';
export const GetResultAsDepartmentAdmin = apiUrl + '/api/Results/GetGroupResultsByDepartmentAdmin';
export const GetCourseOwners = apiUrl + '/api/AdminUsers/GetCourseOwners';
export const GetAllSchedulesFromTheDepartment = apiUrl + '/api/Schedules/GetAllSchedulesFromTheDepartment'
// export const CheckDepartments = apiUrl + '/api/Departments/CheckIfThereIsAnyChanges'
// export const GetUsersInConflict = apiUrl + '/api/Departments/GetUsersInConflict'
// export const SetUpDepartments = apiUrl + '/api/Departments/SetupDepartmentAndUsers'
// export const ResetDepartments = apiUrl + '/api/Departments/ResetDepartmentsAndUsers'
// export const FixUserConflict = apiUrl + '/api/Departments/FixUserConflict'
// export const FixUserConflictsBulk = apiUrl + '/api/Departments/FixUserConflictsBulk'
export const CoursesWithModules = apiUrl + '/api/Courses/GetAllWithModules'
export const EditCourse = apiUrl + '/api/Courses/Edit';
export const EditSchedule = apiUrl + '/api/Schedules/Edit';
export const GetCourseResults = apiUrl + '/api/Results/GetGroupResultsByGroupId'
export const GetModulesBelongedToOrganization = apiUrl + '/api/OrganizationsModules/GetAllModulesBelongedToOrganization'
//! For registeration of new admin
export const SendPhoneValidationOTP = apiUrl + '/api/OrgAdminUserAuth/SendPhoneValidationOTP'
export const ValidateOTP = apiUrl + '/api/OrgAdminUserAuth/ValidatePhoneNumber'
export const AcceptUserAgreement = apiUrl + '/api/OrgAdminUserAuth/AcceptUserAgreement'
// Added 2026-09-07 (see backend/CLAUDE.md) - registration-expiry fix.
export const CheckInvitationStatus = apiUrl + '/api/OrgAdminUserAuth/CheckInvitationStatus'
export const ResendExpiredInvitation = apiUrl + '/api/OrgAdminUserAuth/ResendExpiredInvitation'

export const DashboradResultAsUpperAdmin = apiUrl + '/api/Results/GetGeneralResultAsUpperAdmin'
export const DashboardResultAsDepAdmin = apiUrl + '/api/Results/GetGeneralResultAsDepartmentAdmin'

// ── MV Admin / Shadow mode ─────────────────────────────────────────────────
export const MvAdminAuthorizeUrl       = apiUrl + '/api/MVAdminAuth/authorize-url'
export const MvAdminShadowOrganizations = apiUrl + '/api/MVAdmin/shadow/organizations'
export const MvAdminShadowToken        = apiUrl + '/api/MVAdmin/shadow/token'
